// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export default {
  'LOS_x': {
    'version': '261014',
    'hash': '3a433ca'
  },
  'allow_switching_backend_instance': true
};
/* tslint:enable */
